const { FORMULA } = require("./formula");

const SECTION_TITLES = {
  RELATED_CALCULATORS: "Related Calculators",
  POPULAR_CALCULATORS: "Popular Calculators",
  FAQ_CALCULATORS: "Frequently Asked Questions",
  CATEGORIES_FILTER: "Filter by Categories",
  CALCULATORS: "CALCULATORS",
  MOST_POPULAR: "MOST POPULAR",
};

const CALCULATOR_RADIO = "calculatorRadio";

const SLIDER_VISIBILITY = {
  YES: "Yes",
  NO: "No",
};

const CAROUSEL_DIRECTION_TYPES = {
  LEFT: "left",
  RIGHT: "right",
};

const INPUT_FORMAT = {
  [FORMULA.SIP]: {
    input1: "₹",
    input2: "%",
    input3: "Yr",
  },
  [FORMULA.LUMPSUM]: {
    input1: "₹",
    input2: "%",
    input3: "Yr",
  },
  [FORMULA.HRA]: {
    input1: "₹",
    input2: "₹",
    input3: "₹",
    input4: "₹",
  },
};

const CATEGORIES = {
  ALL: "All",
};

const HOMEPAGE = {
  PAGE_LIMIT: 15,
};

const NO_RESULT_CALCULATOR = {
  TITLE: "Unexpected error occured",
  SUB_TITLE:
    "We’re experiencing some technical difficulties on our end. Our team is working hard to fix this. Meanwhile sometimes, a simple refresh can do the trick.",
  BUTTON: "Go to Buzz home",
};

const POST_CATEGORIES = {
  NEWSLETTER: "Newsletter",
  TRENDING: "Trending",
};

const OUTPUT_FORM = {
  NA: "NA",
};

const CALC_PAGE_LIMIT = 9;

const BRAND_LOGO_URL =
  "https://static.share.market/images/web/944/212/brandlogo78d8e22f.png";

const CALCULATOR_FALLBACK =
  "https://static.share.market/images/web/1352/528/sm_blog_calculator.png";

const MOST_POPULAR_FALLBACK =
  "https://static.share.market/images/web/988/704/sm_blog_most_popular.png";

const ERROR_IMG_URL =
  "https://static.share.market/images/web/2096/937/sm_blog_error_state.png";

const CALCULATOR_SEO_SCHEMA = {
  BRAND_NAME: "share.market",
  CONTEXT: "https://schema.org",
  BRAND_URL: "https://share.market",
  LOGO_URL: BRAND_LOGO_URL,
  BUZZ_URL: "https://share.market/buzz",
  CALCULATOR_HOME_URL:
    "https://share.market/buzz/calculators",
};

const ERROR_TYPE = {
  BELOW_MIN: "BELOW_MIN",
  ABOVE_MAX: "ABOVE_MAX",
};

const CAROUSEL_VARIANT = {
  LIGHT: "LIGHT",
  DARK: "DARK",
};

module.exports = {
  SECTION_TITLES,
  CALCULATOR_RADIO,
  SLIDER_VISIBILITY,
  CAROUSEL_DIRECTION_TYPES,
  INPUT_FORMAT,
  CATEGORIES,
  HOMEPAGE,
  NO_RESULT_CALCULATOR,
  POST_CATEGORIES,
  OUTPUT_FORM,
  CALC_PAGE_LIMIT,
  NO_RESULT_CALCULATOR,
  CALCULATOR_SEO_SCHEMA,
  BRAND_LOGO_URL,
  CALCULATOR_FALLBACK,
  MOST_POPULAR_FALLBACK,
  ERROR_IMG_URL,
  ERROR_TYPE,
  CAROUSEL_VARIANT,
};
